<div class="count">
  <span>{{ formatNumber(minutes) }}:{{ seconds | number : "2.0" }}</span>
</div>
